import React from "react";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  TextField,
  FormControlLabel,
  Checkbox,
  Slide,
  Snackbar
} from "@material-ui/core";
import Http from "../../../Http";
import config from "../../../config";
import { withRouter } from "react-router-dom";
import ACCESS from "../../../ACCESS.js";

class RecibidasPorFacturacion extends TableComponent {
  async componentDidMount() {
    const { id } = this.props.match.params;
    const Resp = await Http.get(`facturacion/one/${id}`);
    let disabled = false;
    let status = 2;
    if (!Resp.error) {
      disabled = Resp.data.status === 3;
      status = Resp.data.status;
    }
    this.tableConfig(
      {
        dataUrl: `facturacion/guiasbyfactura?factura_id=${id}`,
        deleteUrl: false,
        deleteField: false,
        modUrl: false,
      },
      TableOp.Table(
        "Guias",
        [
          { label: "Guia", id: "g_folio" },
          { label: "Origen", id: "origen" },
          { label: "Destino", id: "destino" },
          { label: "Req. Factura", id: "req_factura" },
          { label: "Req Remision", id: "req_remision" },
          { label: "Guia Recibida", id: "recibida", type: "checkbox", callback: this.onValueChange, disabled },
          { label: "Rechazada", id: "rechazada", type: "checkbox", callback: this.onValueChange, disabled },
          { label: "Comentarios", id: "comentarios", type: "input", callback: this.onCommentChange, onBlur: this.onValueChange, disabled },
        ],
        // [{ id: "editg", icon: "edit", cb: this.editGuia }]
      )
    );
    this.table();
    this.setState({
      editguia: {
        recibida: false,
        rechazada: false,
        comentarios: "",
      },
      openDialog: false,
      id,
      status,
    });
  }

  editGuia = (id, row) => {
    this.setState({ openDialog: true, editguia: JSON.parse(JSON.stringify(row)) });
  };

  downloadReport = () => {
    const { id } = this.props.match.params;
    window.location.href = `${config.API_URL}/excel?factura_id=${id}`;
  };

  downloadPagoTransportistas = async () => {
    this.setState({ loadingreport: true });
    const { id } = this.props.match.params;
    const Resp = await Http.get(`transportista/pago-transportista-pdf?id_folio_cyc=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/pdf' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `pago_entrega_cyc_${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loadingreport: false });
  };

  closeEditGuia = () => {
    this.setState({ openDialog: false });
  };

  onValueChange = (event, index, field) => {
    const { tableData } = this.state;
    let value = event.target.value;
    tableData.rows[index][field] = value;
    // this.setState({ tableData });
    this.saveEditGuia(tableData.rows[index]);
  }

  onCommentChange = (event, index, field) => {
    const { tableData } = this.state;
    let value = event.target.value;
    tableData.rows[index][field] = value;
    this.setState({ tableData });
    // this.saveEditGuia(tableData.rows[index]);
  }

  saveEditGuia = async (editguia) => {
    // const { editguia } = this.state;
    const guias = editguia.length ? editguia : [editguia];
    const Resp = await Http.post(`facturacion/recibirguia`, { guias });
    if (!Resp.error) {
      this.setState({
        editguia: {
          recibida: false,
          rechazada: false,
          comentarios: "",
        },
        openDialog: false,
      }, () => {
        this.table();
      });
    }
  }

  recibirFolio = async () => {
    const { tableData } = this.state;
    for (let index = 0; index < tableData.rows.length; index++) {
      tableData.rows[index]['recibida'] = true;
    }
    // this.setState({ tableData }, );
    this.saveEditGuia(tableData.rows)
  }

  cerrarFolio = async () => {
    const { id } = this.state;
    const Resp = await Http.post(`facturacion/cerrarfolio`, { id: id });
    if (!Resp.error) {
      this.setState({
        sbOpen: true,
        sbMsg: 'Folio Cerrado'
      }, () => {
        // this.props.history.goBack()
      }
      );
    } else {
      this.setState({
        sbOpen: true,
        sbMsg: Resp.errMsg
      })
    }
  }

  render() {
    let { editguia, openDialog, id, status, sbOpen = false, sbMsg, loadingreport = false } = this.state;
    editguia = editguia || {};
    const { hasAccess } = this.context
    return (
      <div>
        <div style={{ padding: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>{`Folio de envio #${id}`}</h1>
          <div>
            <Button
              onClick={this.downloadReport}
              color="primary"
              variant="contained"
              style={{ marginRight: 5 }}
              disabled={loadingreport}
            >
              Descargar Reporte
            </Button>
            {/*             <Button
              onClick={this.downloadPagoTransportistas}
              color="primary"
              variant="contained"
              style={{ marginRight: 5 }}
              disabled={loadingreport}
            >
              Descargar Pago Transportista
            </Button> */}
            {status !== 3 && <React.Fragment>
              <Button
                onClick={this.recibirFolio}
                color="primary"
                variant="contained"
                style={{ marginRight: 5 }}
              >
                Recibir Folio
              </Button>
              <Button
                onClick={this.cerrarFolio}
                color="primary"
                variant="contained"
              >
                Cerrar Folio
              </Button>
            </React.Fragment>
            }
          </div>
        </div>
        <this.TableRender />
        {/* Modal Editar */}
        <div>
          <Dialog onClose={this.closeEditGuia} open={openDialog || false}>
            <DialogTitle onClose={this.closeEditGuia}>Editar</DialogTitle>
            <DialogContent dividers>
              <div className="row">
                <div className="col-sm-12">
                  <FormControlLabel
                    control={
                      <Checkbox
                        // disabled={disabled ? disabled : false}
                        checked={editguia.recibida === "SI" ? true : false}
                        onChange={event => this.onValueChange({ target: { value: event.target.checked } }, "recibida")}
                      // name="g_autoservicio"
                      />
                    }
                    label="Recibida"
                  />
                </div>
                <div className="col-sm-12">
                  <FormControlLabel
                    control={
                      <Checkbox
                        // disabled={disabled ? disabled : false}
                        checked={editguia.rechazada === "SI" ? true : false}
                        onChange={event => this.onValueChange({ target: { value: event.target.checked } }, "rechazada")}
                      // name="g_autoservicio"
                      />
                    }
                    label="Rechazada"
                  />
                </div>
                <div className="col-sm-12">
                  <FormControl variant="outlined" className="form-field">
                    <TextField
                      value={editguia.comentarios || ''}
                      onChange={event => this.onValueChange(event, "comentarios")}
                      multiline
                      label="Comentarios"
                      variant="outlined"
                      minRows="2"
                    />
                  </FormControl>
                </div>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.closeEditGuia}>CANCELAR</Button>
              <Button
                color="primary"
                variant="contained"
                onClick={this.saveEditGuia}
              >
                Guardar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <Snackbar
          open={sbOpen}
          onClose={() => { this.setState({ sbOpen: false }) }}
          TransitionComponent={Slide}
          message={<span>{sbMsg}</span>}
        />
      </div>
    );
  }
}

export default withRouter(RecibidasPorFacturacion);
